import "./HomePage2.module.css";
import Header from "@/reusable_sections/Header";
import Portfolio from "./sections/Portfolio";
import NewsletterSignUp from "./sections/NewsletterSignUp";
import BrandsPartners from "./sections/BrandsPartners";
import Testimonials from "./sections/Testimonials";
import Footer from "@/reusable_sections/Footer";
export default function HomePage2() {
  return <div>
      <Header />
      <Portfolio />
      <NewsletterSignUp />
      <BrandsPartners />
      <Testimonials />
      <Footer />
    </div>;
}